/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Microsoft_HintInputs */

const cs_settings_calendar_microsoft_hint = /** @type {(inputs: Settings_Calendar_Microsoft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberete, který Microsoft účet použít. Osobní Outlook.com / Hotmail i firemní Microsoft 365.`)
};

const en_settings_calendar_microsoft_hint = /** @type {(inputs: Settings_Calendar_Microsoft_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ll pick which Microsoft account to use. Personal Outlook.com / Hotmail or a work Microsoft 365 mailbox both work.`)
};

/**
* | output |
* | --- |
* | "You’ll pick which Microsoft account to use. Personal Outlook.com / Hotmail or a work Microsoft 365 mailbox both work." |
*
* @param {Settings_Calendar_Microsoft_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_microsoft_hint = /** @type {((inputs?: Settings_Calendar_Microsoft_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Microsoft_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_microsoft_hint(inputs)
	return cs_settings_calendar_microsoft_hint(inputs)
});